import axios from "axios";
import toast from "react-hot-toast";
import { getApi } from "../backend";

export const getAllPlaylists = () => {
  return axios
    .get(`${getApi()}/api/v1/playlist`)
    .then((res) => {
      console.log(res.data);
      if (res.data.success) {
        return res.data.data;
      } else {
        toast.error("Error in getting playlists");
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error("Error in getting playlists");
    });
};

export const deletePlaylist = async (id) => {
  return fetch(`${getApi()}/api/v1/playlist/delete/${id}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(body),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getFilteredPlaylists2 = (search, page, limit, sort, data) => {
  return fetch(
    `${getApi()}/api/v1/playlist/getFilteredPlaylists/?search=${search}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
